import { Helmet } from 'react-helmet-async'
import WindowContainer from '../components/layout/WindowContainer'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import Hero from '../components/sections/Hero'
import AboutStats from '../components/sections/AboutStats'
import ProblemCards from '../components/sections/ProblemCards'
import FeatureGrid from '../components/sections/FeatureGrid'
import PricingTiers from '../components/sections/PricingTiers'
import FAQ from '../components/sections/FAQ'
import { faqContent } from '../data/landing-content'

export default function NewLandingPage() {
  // Structured Data - SoftwareApplication
  const softwareAppSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "BankStatementReader",
    "applicationCategory": "FinanceApplication",
    "operatingSystem": "Web",
    "offers": [
      {
        "@type": "Offer",
        "name": "Free Trial",
        "price": "0",
        "priceCurrency": "USD",
        "description": "5 statements per month with XLSX & CSV export"
      }
    ],
    "description": "Extract transactions from PDF bank statements with OCR and export to Excel, CSV, or JSON.",
    "url": "https://bankstatementreader.com"
  }

  // Structured Data - FAQ
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqContent.questions.map(q => ({
      "@type": "Question",
      "name": q.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": q.answer
      }
    }))
  }

  return (
    <>
      <Helmet>
        <title>BankStatementReader — Automated Statement Processing</title>
        <meta name="description" content="Extract transactions from PDF bank statements with OCR and export to Excel, CSV, or JSON. PaddleOCR powered. Free tier available." />
        <link rel="canonical" href="https://bankstatementreader.com/" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="BankStatementReader — Automated Statement Processing" />
        <meta property="og:description" content="Extract transactions from PDF bank statements and export to Excel, CSV, or JSON." />
        <meta property="og:url" content="https://bankstatementreader.com/" />
        <meta property="og:image" content="https://bankstatementreader.com/og-cover.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="BankStatementReader — Automated Statement Processing" />
        <meta name="twitter:description" content="PDF statement extraction • Excel/CSV/JSON export • PaddleOCR" />
        <meta name="twitter:image" content="https://bankstatementreader.com/og-cover.png" />

        {/* JSON-LD Structured Data - Software Application */}
        <script type="application/ld+json">
          {JSON.stringify(softwareAppSchema)}
        </script>

        {/* JSON-LD Structured Data - FAQ */}
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <WindowContainer>
        <Header />
        <Hero />

        <section className="mt-22">
          <AboutStats />
        </section>

        <ProblemCards />
        <FeatureGrid />
        <PricingTiers />
        <FAQ />

        <Footer />
      </WindowContainer>
    </>
  )
}
